import UtilityDrawer from '../utility-drawer/utility-drawer.component';
import { useTranslation } from 'react-i18next';
import UtilityDrawerBody from '../utility-drawer/utility-drawer-body/utility-drawer-body.component';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import EventTimeline from 'components/event-timeline/event-timeline.component';
import { useGetAccountChangeLogsQuery } from 'api/user-domain/user-domain';
import { ReactNode } from 'react';
import { mapAccountChangeLogsToTimelineEntries } from './customer-status-history-drawer.utils';

type CustomerStatusHistoryDrawerProps = {
  open: boolean;
  close: () => void;
  drawerData?: { customerId: string };
  children?: ReactNode;
};

const CustomerStatusHistoryDrawer = ({
  open,
  close,
  drawerData,
  children,
}: CustomerStatusHistoryDrawerProps) => {
  const { t } = useTranslation();

  const { data, isLoading } = useGetAccountChangeLogsQuery(
    !!drawerData?.customerId ? { userId: drawerData?.customerId } : skipToken,
  );

  return (
    <UtilityDrawer
      open={open}
      onClose={close}
      data-testid="CustomerStatusHistoryDrawer.UtilityDrawer"
      title={t('drawer.blockedAccountDetailsDrawer.datagrid.title')}
      isLoading={isLoading}
    >
      <UtilityDrawerBody>
        <EventTimeline
          title={t('drawer.blockedAccountDetailsDrawer.timeline.title')}
          data-testid="CustomerStatusHistoryDrawer.EventTimeline"
          entries={mapAccountChangeLogsToTimelineEntries(data ?? [], t)}
          emptyMessage={
            data
              ? t('drawer.blockedAccountDetailsDrawer.timeline.empty')
              : undefined
          }
          isLoading={isLoading}
        />
      </UtilityDrawerBody>
      {children}
    </UtilityDrawer>
  );
};

export default CustomerStatusHistoryDrawer;
